<template>
  <div class="bankeys-header-block" :class="activeClass">
    <div class="bankeys-header">
      <div class="logo-block" @click="goHome()">
        <div class="logo" :style="logoUrl"></div>
        <div class="page-name" v-if="this.title">{{ this.title }}</div>
      </div>
      <div class="menu-block" v-if="this.quick">
        <div class="menu-item " :class="$route.name === 'home' && 'active'" @click="goHome()">首页</div>
        <div class="menu-item " :class="$route.name === 'download' && 'active'" @click="goDownload()">下载APP</div>
      </div>
      <div class="login-block" v-if="this.menu">
        <div class="login-btn-group" v-if="hasUser === false && !navoOpened">
          <div class="login-btn font-hover" @click="goLoginAndRegister()">登录</div>
          <div class="register-btn font-hover" @click="goLoginAndRegister(true)">注册</div>
        </div>
        <div class="user-munu" v-show="hasUser === true">
          <UserMenu @logout="logout" :openH5Nav.sync="openH5Nav" :user="user" />
        </div>
        <div class="ProtoPie-btn" @click="openNav()">
          <div class="icon" :class="activeClass"><span></span></div>
        </div>
      </div>
    </div>
    <div class="bankeys-header-content" v-if="!openH5Nav && this.menu">
      <div class="bankeys-heade-list">
        <div class="bankeys-heade-item" @click="goHome()">首页</div>
        <div class="bankeys-heade-item" @click="goDownload()" v-if="!isInApp">下载APP</div>
      </div>
      <div class="bankeys-heade-btn" v-if="!hasUser">
        <div class="h5-login-btn" @click="goLoginAndRegister()">登录</div>
        <div class="h5-register-btn" @click="goLoginAndRegister(true)">注册</div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from './UserMenu'
import { mapActions, mapMutations } from 'vuex'
import { goLoginPage, isInEsignApp } from '@/lib/utils'

const defaultLogoUrl = 'https://asset.esign.cn/usercenterFront/img/pc_logo%402x.png'

export default {
  name: 'Header',
  components: { UserMenu },
  data() {
    return {
      navoOpened: false,
      openH5Nav: false,
      user: {},
      userVm: {},
      isInApp: isInEsignApp(),
    }
  },
  props: {
    logo: String,
    title: String,
    menu: Boolean,
    quick: Boolean,
  },
  computed: {
    logoUrl() {
      return { backgroundImage: `url('${this.logo || defaultLogoUrl}')` }
    },
    activeClass() {
      return this.navoOpened ? 'active' : ''
    },
    hasUser() {
      return !!this.user.base
    },
    avatarImg() {
      return this.user && this.user.head
    },
  },
  watch: {
    // 同步汉堡按钮的状态
    openH5Nav(val) {
      this.navoOpened = val
    },
  },
  async created() {
    if (this.menu) this.user = (await this.getUserInfoForBankey()) || {}
  },
  methods: {
    ...mapActions('user', ['getUserInfoForBankey']),
    ...mapMutations('user', ['setUserInfo']),
    goHome() {
      // 单纯下载页，则不用跳转首页
      if (!this.title) return
      this.$router.push({ path: '/landing/bankeys', query: this.$route.query })
      this.navoOpened = false
    },
    goDownload() {
      this.$router.push({ path: '/landing/bankeys/download', query: this.$route.query })
      this.navoOpened = false
    },
    goLoginAndRegister(isRegister = false) {
      goLoginPage(isRegister ? 'register' : 'login')
    },
    // 点击汉堡按钮
    openNav() {
      // 如果是个人信息展开状态
      if (this.openH5Nav) {
        this.openH5Nav = false
      } else {
        this.navoOpened = !this.navoOpened
      }
    },
    logout() {
      this.user = {}
      this.setUserInfo(null)
    },
  },
}
</script>

<style lang="less" scoped>
.bankeys-header-block {
  // position: fixed;
  // top: 0;
  // left: 0;
  // width: 100%;
  // z-index: 10000;
  flex: 0 0 auto;
  .bankeys-header-content {
    display: none;
  }
}
.bankeys-header {
  padding-left: 90px;
  height: 60px;
  background: rgba(38, 39, 41, 1);
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 300;
  color: rgba(219, 219, 219, 1);
  .logo-block {
    display: flex;
    cursor: pointer;
    .logo {
      margin-right: 12px;
      width: 92px;
      height: 30px;
      background-size: contain;
      background-position: right center;
      background-repeat: no-repeat;
    }
    .page-name {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 30px;
      height: 30px;
      &::before {
        content: '';
        margin-right: 10px;
        display: inline-block;
        margin-bottom: 3px;
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background: #fff;
      }
    }
  }

  .menu-block {
    flex: 1;
    display: flex;
    margin-left: 60px;
    .menu-item {
      margin-right: 40px;
      cursor: pointer;
      &.active {
        font-size: 14px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }
    }
  }

  .login-block {
    .login-btn-group {
      margin-right: 80px;
      .login-btn {
        margin-right: 38px;
        display: inline-block;
        cursor: pointer;
        padding: 2px;
      }
      .register-btn {
        cursor: pointer;
        display: inline-block;
        border-radius: 2px;
        border: 1px solid rgba(219, 219, 219, 1);
        padding: 6px 20px;
        &:hover {
          border-color: #e61717;
          background-color: #e61717;
        }
      }
    }
    .user-munu {
      padding-right: 20px;
      .user-munu-h5-img {
        display: none;
      }
    }
    .ProtoPie-btn {
      display: none;
    }
  }

  .font-hover {
    transition: all 0.4s ease-in-out;
    &:hover {
      color: #ffffff;
    }
  }
}
@media only screen and (max-width: 768px) {
  .bankeys-header-block {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // padding-bottom: 60px;
    &.active {
      height: 100vh;
      .bankeys-header-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        background-color: #ffffff;
        padding-bottom: 80px;
        z-index: 100001;
        .bankeys-heade-list {
          flex: 1;
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          .bankeys-heade-item {
            padding: 17px 0;
            margin: 0 24px;
            border-bottom: 1px solid #e1e3e6;
            .un-realname {
              font-size: 14px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              float: right;
            }
          }
        }
        .bankeys-heade-btn {
          padding: 0 24px;
          .h5-login-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 44px;
            background: rgba(230, 55, 64, 1);
            border-radius: 4px;
            font-size: 18px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 21px;
          }
          .h5-register-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 44px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            opacity: 0.4;
            border: 1px solid rgba(204, 204, 204, 1);
            font-size: 16px;
            font-weight: 500;
            color: #72728f;
          }
        }
      }
    }
  }
  .bankeys-header {
    padding: 0 16px;
    height: 50px;
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: space-between;
    .logo-block {
      display: flex;
      cursor: pointer;
      .logo {
        margin-right: 6px;
        width: 80px;
        height: 24px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
      .page-name {
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        height: 23px;
        line-height: 24px;
        &::before {
          content: '';
          margin-right: 6px;
          display: inline-block;
          margin-bottom: 3px;
          width: 5px;
          height: 5px;
          border-radius: 5px;
          background: #fff;
        }
      }
    }

    .menu-block {
      display: none;
    }

    .login-block {
      display: flex;
      align-items: center;
      .login-btn-group {
        margin-right: 0px;
        .login-btn {
          display: none;
        }
        .register-btn {
          cursor: pointer;
          display: inline-block;
          border-radius: 0;
          border: none;
          padding: 0;
          &:hover {
            background-color: transparent;
          }
        }
      }
      .ProtoPie-btn {
        display: inline-block;
        margin-left: 25px;
        .icon {
          height: 24px;
          width: 24px;
          overflow: hidden;
          text-indent: 100%;
          white-space: nowrap;
          color: transparent;
          z-index: 1100;
          position: relative;

          span {
            position: absolute;
            left: 50%;
            top: 50%;
            bottom: auto;
            right: auto;
            background-color: #fff;
            height: 3px;
            width: 24px;
            transform: translateX(-50%) translateY(-50%);
            transition: background-color 0.2s;

            &::after {
              position: absolute;
              background-color: #fff;
              height: 3px;
              width: 24px;
              content: '';
              left: 0;
              transition: transform 0.2s;
              transform: translateY(9px);
            }

            &::before {
              position: absolute;
              background-color: #fff;
              height: 3px;
              width: 24px;
              content: '';
              left: 0;
              transition: transform 0.2s;
              transform: translateY(-9px);
            }
          }

          &.active {
            span {
              background-color: transparent;
            }

            span::after {
              transform: rotate(-45deg);
            }

            span::before {
              transform: rotate(45deg);
            }
          }
        }
      }
      .user-munu {
        padding-right: 0;
      }
    }

    .font-hover {
      transition: all 0.4s ease-in-out;
      &:hover {
        color: #ffffff;
      }
    }
  }
}
</style>
